import { render, staticRenderFns } from "./imageCarousel.vue?vue&type=template&id=563f883e&"
import script from "./imageCarousel.vue?vue&type=script&lang=js&"
export * from "./imageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('563f883e')) {
      api.createRecord('563f883e', component.options)
    } else {
      api.reload('563f883e', component.options)
    }
    module.hot.accept("./imageCarousel.vue?vue&type=template&id=563f883e&", function () {
      api.rerender('563f883e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2lzx6Yoi3EHt2/JS/imageCarousel.vue"
export default component.exports